/**
 * @generated SignedSource<<708c1bbd91c0ce7794de647ad883ea2d>>
 * @relayHash a8d997cf9f56d7a9bc9c3a4673a4ab05
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 392e69b59b157550f874185ece3f2558dca2cfd138ebbca83e163ba479f415b2

import type { ConcreteRequest } from 'relay-runtime';
export type getIsRovoEnabledQuery$variables = {
  cloudId: string;
};
export type getIsRovoEnabledQuery$data = {
  readonly atlassianStudio_userSiteContext: {
    readonly isRovoEnabled?: boolean | null;
  } | null;
};
export type getIsRovoEnabledQuery = {
  response: getIsRovoEnabledQuery$data;
  variables: getIsRovoEnabledQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isRovoEnabled"
    }
  ],
  "type": "AtlassianStudioUserSiteContextOutput"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "getIsRovoEnabledQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "atlassianStudio_userSiteContext",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getIsRovoEnabledQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "atlassianStudio_userSiteContext",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "392e69b59b157550f874185ece3f2558dca2cfd138ebbca83e163ba479f415b2",
    "metadata": {},
    "name": "getIsRovoEnabledQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4e6658c9c4fce21189d6b3b9b3b4e535";

export default node;
